import auth from '../auth'
import React, { Component } from 'react'
import { grey300 } from 'material-ui/styles/colors'
import { Card, CardTitle, CardText } from 'material-ui/Card'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import TextField from 'material-ui/TextField'
import RaisedButton from 'material-ui/RaisedButton'
import ClearFix from 'material-ui/internal/ClearFix'
import muiThemeable from 'material-ui/styles/muiThemeable'

class ResetPassword extends Component<any, any> {
  static childContextTypes = {
    muiTheme: React.PropTypes.object
  }

  componentWillMount () {
    this.setState({
      muiTheme: getMuiTheme()
    })
  }

  getChildContext () {
    return {
      muiTheme: this.state.muiTheme
    }
  }

  constructor (props) {
    super(props)
    this.state = {
      email: '',
      submitting: false,
      error: false,
      emailSent: false
    }
  }

  handleEmailChange (event) {
    this.setState({
      email: event.target.value
    })
  }

  handleSubmit (event) {
    event.preventDefault()
    this.setState({ submitting: true })
    auth.resetPassword(this.state.email, (error) => {
      if (error) {
        return this.setState({
          error: true,
          submitting: false
        })
      }

      this.setState({
        error: false,
        submitting: false,
        emailSent: true
      })
    })
  }

  render () {
    const style = {
      root: {
        width: '100%',
        height: '100%',
        background: grey300
      },
      container: {
        width: 360,
        margin: '0 auto',
        padding: '100px 0'
      },
      card: {
      },
      title: {
        backgroundColor: this.props.muiTheme.palette.primary1Color
      },
      button: {
        float: 'right',
        marginTop: 14
      }
    }

    return (
      <div style={style.root}>
        <div style={style.container}>
          <Card style={style.card}>
            <CardTitle title='Forgot your password?' style={style.title} titleColor='white' />
            <CardText>
              {this.state.emailSent ? <p>An email has been sent to {this.state.email} with a link to reset your password.</p> : (
                <div>
                  <p>Enter the email you used to sign up, and we'll send you a link to reset your account password.</p>
                  <ClearFix>
                    <form method='post' name='reset-password' onSubmit={this.handleSubmit.bind(this)}>
                      <TextField name='email' floatingLabelText='Email' fullWidth errorText={this.state.error ? 'Failed to submit password reset request' : ''} onChange={this.handleEmailChange.bind(this)} />
                      <RaisedButton disabled={this.state.submitting} label='Send Password Reset Link' style={style.button} type='submit' />
                    </form>
                  </ClearFix>
                </div>
              )}
            </CardText>
          </Card>
        </div>
      </div>
    )
  }
}

export default muiThemeable()(ResetPassword)
